import PropTypes from "prop-types";
import { Col, Row } from "reactstrap";
import { useState, useEffect } from "react";
import { toast } from "../../../../core/helpers/message-helper";
import FormModal from "../../../../core/ui/components/FormModal";
import InputController from "../../../../core/ui/components/InputController";
import SelectController from "../../../../core/ui/components/SelectController";
import { useForm } from "react-hook-form";
import {
    asignarActividadesColaboradores,
    selectActividad,
} from "../../../Actividades/services/actividades-service";
import { selectEmpleadosConReglasOSecuencias } from "../../../Personas/services/empleados-service";

const REQUIRED_RULE = {
    required: "Este campo es requerido",
};

const FormAsignarActividades = ({ modalState, onCreate }) => {
    const [selectActividades, setSelectActividades] = useState([]);
    const [empleados, setEmpleados] = useState([]);

    useEffect(async () => {
        const resp = await selectActividad(37);
        if (!resp.status) return toast.error(resp.message);
        setSelectActividades(resp.data);
    }, []);

    useEffect(async () => {
        const resp = await selectEmpleadosConReglasOSecuencias();
        if (!resp.status) return toast.error(resp.message);

        setEmpleados(
            resp.data.map((empleado) => {
                return {
                    label: empleado.info_persona,
                    value: empleado.id,
                };
            })
        );
    }, []);

    const defaultValues = {
        empleados: [],
        actividad_id: "",
        fechaInicioActividad: "",
        fechaFinActividad: "",
    };

    const form = useForm({ defaultValues });

    const onSubmit = async (data) => {
        const dataActividad = {
            ...data,
            actividad_id: data.actividad_id.value,
            empleados: data.empleados.map((emp) => emp.value),
        };

        const resp = await asignarActividadesColaboradores(dataActividad);
        if (!resp.status) return toast.error(resp.message);

        modalState.close();
        form.reset(defaultValues);
        onCreate(resp);
    };

    return (
        <FormModal
            size="lg"
            form={form}
            isOpen={modalState.show}
            onSubmit={onSubmit}
            id="formAsignarActividades"
            headerTitle="Asignar Actividades"
            closeModal={() => modalState.close()}
        >
            <Row>
                <Col sm={6}>
                    <SelectController
                        label="Colaborador"
                        isMulti={true}
                        options={empleados}
                        name="empleados"
                        rules={REQUIRED_RULE}
                        errors={form.formState.errors}
                        control={form.control}
                    />
                </Col>
                <Col sm={6}>
                    <SelectController
                        label="Actividad"
                        errors={form.formState.errors}
                        control={form.control}
                        name="actividad_id"
                        rules={REQUIRED_RULE}
                        options={selectActividades.map((actividad) => {
                            return {
                                label: actividad.nombre,
                                value: actividad.id,
                            };
                        })}
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        type="date"
                        errors={form.formState.errors}
                        control={form.control}
                        rules={REQUIRED_RULE}
                        name="fechaInicioActividad"
                        label="Fecha inicio de la actividad"
                    />
                </Col>
                <Col sm={6}>
                    <InputController
                        type="date"
                        errors={form.formState.errors}
                        control={form.control}
                        name="fechaFinActividad"
                        label="Fecha fin de la actividad"
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormAsignarActividades.propTypes = {
    modalState: PropTypes.object,
    onCreate: PropTypes.func,
};

export default FormAsignarActividades;
